/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 上架任务列表 的 **请求配置**
 *
 * @分类 旧接口文档/上架
 * @请求头 `POST /erp/upshelf/getList`
 */
const postGetListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/upshelf/getList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 上架任务列表 的 **请求函数**
 *
 * @分类 旧接口文档/上架
 * @请求头 `POST /erp/upshelf/getList`
 */
export const postGetList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetListRequestConfig, requestData), ...args);
};
postGetList.requestConfig = postGetListRequestConfig;
/**
 * 接口 上架任务列表 - 筛选项 的 **请求配置**
 *
 * @分类 旧接口文档/上架
 * @请求头 `GET /erp/Upshelf/optionsForUpshelfList`
 */
const getOptionsForUpshelfListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Upshelf/optionsForUpshelfList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getOptionsForUpshelfList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 上架任务列表 - 筛选项 的 **请求函数**
 *
 * @分类 旧接口文档/上架
 * @请求头 `GET /erp/Upshelf/optionsForUpshelfList`
 */
export const getOptionsForUpshelfList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getOptionsForUpshelfListRequestConfig, requestData),
    ...args
  );
};
getOptionsForUpshelfList.requestConfig = getOptionsForUpshelfListRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/upshelf.js